import { Type } from 'class-transformer';
import { ActivityFeedResultDto } from './activity-feed-result-dto';
import { UserDashboardItemResultDto } from './user-dashboard-item-result-dto';

export class UserDashboardResultDto {
  @Type(() => UserDashboardItemResultDto)
  dashboardItems: Array<UserDashboardItemResultDto>;

  @Type(() => ActivityFeedResultDto)
  activityItems: Array<ActivityFeedResultDto>;

  message: string;
  status: string;
}
